import gql from 'graphql-tag';

export const FastForwardParticipant = gql`
  mutation FastForwardParticipant($organizationId: ID!, $participantId: ID!) {
    fastForwardParticipant(organizationId: $organizationId, participantId: $participantId) {
      id
    }
  }
`;
